import axios from 'axios';
import { API_BASE_URL } from "./contests";

export type ParticipantEntry = {
    participant_id: number;
    participant_name: string;
    profile_picture: string;
    total_entries: number;
};

export interface DashboardStats {
    totalParticipants: number;
    totalContests: number;
    maxProgress: number;
    avgProgress: number;
    mostProgressParticipant: {
        participant_id: number;
        participant_name: string;
        profile_picture: string;
        total_progress: number;
    };
    mostActiveParticipant: {
        participant_id: number;
        participant_name: string;
        profile_picture: string;
        total_entries: number;
    };
    mostVersatileParticipant: {
        participant_id: number;
        participant_name: string;
        profile_picture: string;
        total_entries: number;
    };
}

// src/types/ProgressTypes.ts
export interface ParticipantProgress {
    participantId: number;
    participantName: string;
    profilePicture: string;
    totalProgress: number;
    totalEntries: number;
    totalParticipation: number;
}

export interface ParticipantDetails {
    contestId: number;
    contestName: string;
    totalProgress: number;
    totalEntries: number;
    participantName: string;
    profilePicture: string;
}

const buildDaysQuery = (days?: number): string => (days ? `?days=${days}` : '');

// Fetch all participants' progress
export const fetchAllParticipantsProgress = async (days?: number) => {
    const { data } = await axios.get(`${API_BASE_URL}/progress/participants${buildDaysQuery(days)}`);
    return data;
};

// Fetch most frequent participants
export const fetchMostFrequentParticipants = async (days?: number) => {
    const { data } = await axios.get(`${API_BASE_URL}/progress/frequency${buildDaysQuery(days)}`);
    return data;
};

// Fetch participant details
export const fetchParticipantDetails = async (participantId: number, days?: number) => {
    const { data } = await axios.get(`${API_BASE_URL}/progress/participant/${participantId}${buildDaysQuery(days)}`);
    return data;
};

export const fetchParticipantTrends = async (participantId: number, days = -1) => {
    const { data } = await axios.get(`${API_BASE_URL}/progress/trends/${participantId}${buildDaysQuery(days)}`);
    return data;
};


// Fetch dashboard statistics
export const fetchDashboardStats = async (days?: number): Promise<DashboardStats> => {
    const { data } = await axios.get(`${API_BASE_URL}/progress/stats${buildDaysQuery(days)}`);
    return {
        totalParticipants: data.total_participants,
        totalContests: data.total_contests,
        maxProgress: data.max_progress,
        avgProgress: data.avg_progress,
        mostProgressParticipant: JSON.parse(data.most_progress_participant)[0],
        mostActiveParticipant: JSON.parse(data.most_active_participant)[0],
        mostVersatileParticipant: JSON.parse(data.most_versatile_participant)[0],
    };
};

// Fetch progress overview
export const fetchProgressOverview = async (days?: number) => {
    const response = await axios.get(`${API_BASE_URL}/progress/overview${buildDaysQuery(days)}`);
    return response.data;
};

// Fetch frequency overview
export const fetchFrequencyOverview = async (days?: number) => {
    const response = await axios.get(`${API_BASE_URL}/progress/frequency${buildDaysQuery(days)}`);
    return response.data;
};
